<template>
  <div>
    <modal @cancel="setIsOpen(false)" :open="isOpen">
      <transition name="slide">
        <div v-if="this.currentStep == 1" class="wizard step-1">
          <step-one :item="item"></step-one>
        </div>
        <div v-if="this.currentStep == 2" class="wizard step-2">
          <step-two
            :item="item"
            :leadMasks="leadMasks"
            :businesskits="businesskits"
            @create="create()"
          ></step-two>
        </div>
        <div v-if="this.currentStep == 3" class="wizard step-3">
          <success :item="item"></success>
        </div>
      </transition>
    </modal>
  </div>
</template>
<script>
import Api from "@/api/Project.js";
import UserApi from "@/api/User.js";
import BusinessKitApi from "@/api/BusinessKit.js";
import LeadMaskApi from "@/api/LeadMask";
import ProjectApi from "@/api/Project";
import Field from "@/components/helpers/DataInput/Field";
import Modal from "@/components/helpers/Layout/NewModal";
import Permission from "@/classes/Permission";
import Ui from "@/classes/Ui";
import ProjectBusinesskitAssignement from "./ProjectBusinesskitAssignement";
import StepOne from "@/components/pages/projects/wizard/StepOne";
import StepTwo from "@/components/pages/projects/wizard/StepTwo";
import Success from "@/components/pages/projects/wizard/Success";

export default {
  components: {
    Ui,
    Modal,
    StepOne,
    StepTwo,
    Success
  },
  data() {
    return {
      model: "projects",
      isOpen: true,
      api: new Api(),
      item: {
        user_ids: []
      }, // The Project
      leadMasks: [], // Organization's Lead Masks
      organizations: [], // Possible Organizations (NOT IMPLEMENTED!)
      masterOrganizationId: undefined, // Allow overwriting user's org ID. This is needed for root accounts
      errors: [], // API errors
      businesskits: [], // Organization's Business Kits
      users: [] // Organization's users
    };
  },
  computed: {
    currentStep() {
      return this.$store.getters.getProjectWizardStep;
    },
    organization_id() {
      if (this.masterOrganizationId) {
        return this.masterOrganizationId;
      } else {
        return this.$store.state.current_user.organization_id;
      }
    }
  },
  mounted() {
    this.$store.commit("SET_PROJECT_WIZARD_STEP", 1);
    this.retrieveLeadSheets();
    this.retrieveUsers();
    this.retrieveBusinesskits();
  },
  methods: {
    handleUserInvite(user) {
      this.item.user_ids.push(user.id);
      this.retrieveUsers();
    },
    // Create the project
    async create() {
      let api = new ProjectApi();
      try {
        let project = await api.post(this.item);

        // Assign selected users to project
        if (this.item.user_ids) {
          await api.assign_users(this.item.user_ids, project.id);
        }

        // If business kit is selected assign to project
        if (this.item.business_kit_id) {
          await api.assign_businesskit(this.item.business_kit_id, project.id);
        }
        this.item = project;
        this.nextStep();
      } catch (err) {
        console.warn(err);
      }
    },
    setIsOpen(bool) {
      this.isOpen = bool;
      if (!bool && !this.currentPlanIsTalent) {
        this.view = null;
      }
    },
    nextStep() {
      // Go to next step
      this.$store.commit("RESET_PROJECT_WIZARD_ERRORS");
      this.$store.commit("INCREMENT_PROJECT_WIZARD_STEP", 1);
    },
    async retrieveLeadSheets() {
      let api = new LeadMaskApi();
      this.leadMasks = await api.all_for_association();
    },
    async retrieveUsers() {
      let api = new UserApi();
      let response = await api.all({
        organization_id: this.organization_id,
        per_page: 1000
      });
      this.users = response.resources;
    },
    async retrieveBusinesskits() {
      let params = {
        organization_id: this.organization_id,
        per_page: 1000
      };

      let api = new BusinessKitApi();
      let response = await api.all(params);
      this.businesskits = response.resources;
    },
    updateUsers(payload) {
      this.assigned_users = payload;
    },
    updateBusinesskits(payload) {
      this.assigned_businesskits = payload;
    }
  },
  watch: {
    errors(errors) {
      this.error = undefined;
      this.errors.forEach(error => {
        if (error.field_name == "start_date") {
          this.start_date_error = this.$t(error.code);
        }
        if (error.field_name == "end_date") {
          this.end_date_error = this.$t(error.code);
        }
      });
    },
    organization_id(id) {
      this.retrieveLeadSheets();
      this.retrieveUsers();
      this.retrieveBusinesskits();
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-background {
  height: 100vh;
  width: 100vw;
  background-color: rgba(33, 39, 54, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  transition: 0.4s all ease;
}
.actions {
  text-align: right;
  margin-top: 20px;
}
</style>
<style lang="scss">
.wizard {
  background-color: #fff;
  // height: 90vh;
  max-height: 90vh;
  max-width: 480px;
  display: flex;
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
  transform: translate(0, -50%);
  margin-left: auto;
  margin-right: auto;
  z-index: 30;
  border-radius: 4px;
  overflow-y: auto;
  @media (max-width: 575px) {
    padding-top: 2em;
  }
  @media (max-width: 768px) {
    margin-top: 0;
  }
  .lead-sheet-selector {
    width: 100%;
  }
  .cancel {
    color: $sensual;
    font-size: 14px;
    font-weight: $font-medium;
    transition: all 0.15s ease-out;
    &:hover {
      color: $sensual-dark;
    }
    &:active {
      color: $sensual-darker;
    }
  }

  .project-update--form {
    padding: 0px 40px 10px 40px;
    overflow-y: auto;
    max-height: auto;
  }
  .project-update {
    width: 100%;
    overflow-y: auto;
    max-height: auto;
    .field .optional {
      display: none;
    }
    .wizard-footer {
      bottom: 0;
      height: 80px;
      background-color: #f3f5f6;
      text-align: right;
      width: 100%;
      padding: 1em 0;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 40px;
      border-radius: 4px;
      .cancel {
        cursor: pointer;
      }
    }
    .wizard-toolbar {
      background: $ink-dark;
      border-radius: 4px 4px 0 0;
      height: 80px;
      padding: 1.5em 0 1em;
      color: #fff;
      user-select: none;
      p {
        font-size: 12px;
        font-weight: $font-regular;
        text-align: left;
      }
      @media (max-width: 575px) {
        display: none;
      }
      .bar {
        border: 2px solid transparent;
        border-radius: 3px;
        margin: 0 auto;
        margin-bottom: 0.5em;
      }
      .active {
        color: $sensual;
        .bar {
          border-color: $sensual;
        }
      }
      .inactive {
        color: #82989c;
        .bar {
          border-color: #82989c;
        }
      }
      .done {
        color: #50b83c;
        .bar {
          border-color: #50b83c;
        }
      }
    }

    .progress-step-1 {
      padding: 0px 10px 0px 30px;
    }
    .progress-step-2 {
      padding: 0px 30px 0px 10px;
    }

    .user-invite {
      padding: 0;
      h4 {
        display: none;
      }
    }

    .project-user-assignement--filter h3 {
      display: none !important;
    }
    .project-user-assignement--collection {
      overflow: hidden;
    }
    .table th {
      display: none;
    }
    .form-subtitle {
      color: #6a7a8a;
      margin: 1em 0;
    }
    .grid-2 {
      justify-content: space-between;
    }

    .grid-3 {
      justify-content: center;
      align-items: flex-start;
      text-align: center;
    }
    h2 {
      padding: 0px 40px;
      font-weight: $font-regular;
      font-size: 26px;
      line-height: 32px;
      color: $ink;
      margin-bottom: 10px;
    }
  }

  .leadsheet-box {
    width: 170px;
    height: 176px;
    background-color: #f3f5f6;
    text-align: center;
    border: 2px solid #f3f5f6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s ease-out;
    @media (max-width: 575px) {
      margin-bottom: 0.5em;
    }
    img {
      margin-top: 1.5em;
    }
    &.selected {
      border: 2px solid #007aff;
    }
  }

  .input--datepicker {
    padding-left: 1.5em;
  }
  .vdp-datepicker__clear-button {
    position: absolute;
    left: 0;
    top: 8px;
    font-size: 1.5em;
    color: $pastel-dark;
    i {
      font-style: normal;
    }
  }

  h4 {
    font-weight: 400;
    font-size: 16px;
    color: #6a7a8a;
    i {
      font-size: 18px;
      vertical-align: text-bottom;
    }
    &.title {
      margin-bottom: 1.2em;
    }
  }

  h3 {
    font-weight: $font-regular;
    font-size: 26px;
    line-height: 32px;
    color: $ink;
  }
  .additional_data--content {
    background-color: #fbfbfb;
    margin: 2px;
    padding-left: 10px;
    padding-right: 5px;
  }
  .additional_data--title {
    font-size: 16px;
    color: #333;
    cursor: pointer;
  }
}

@media (max-width: 575px) {
  .wizard .project-update--form {
    padding: 0px 20px 10px 20px;
  }
  .wizard .project-update .wizard-footer {
    padding: 0px 20px;
  }
  .wizard .project-update h2 {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ProjectWizard.vue?528a45d7